import fetch from './fetch';

export default {
  getArbsFormulas: function({baseUrl}) {
    return fetch(baseUrl, `/api/v1/arb_formulas`);
  },
};
